export enum FETCH_STATUS {
	READY = 'READY',
	FETCHING = 'FETCHING',
	ERROR = 'ERROR'
}
